(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["historia-audio"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ak-audio-player')) {
    class AkAudioPlayer extends HTMLElement {
      connectedCallback() {
        this.audio = this.querySelector('[data-audio]');
        if (!this.audio) return;
        this.playBtn = this.querySelector('[data-play]');
        this.seekInput = this.querySelector('[data-seek]');
        this.volumeInput = this.querySelector('[data-volume]');
        this.muteBtn = this.querySelector('[data-mute]');
        this.speedBtn = this.querySelector('[data-speed]');
        this.currentEl = this.querySelector('[data-current]');
        this.durationEl = this.querySelector('[data-duration]');
        this.speeds = [1, 1.25, 0.75];
        this.speedLabels = ['normal', 'mais rápida', 'mais lenta'];
        this.speedIndex = 0;
        this.isSeeking = false;
        this.lastSave = 0;
        this.started = false;
        this.completed = false;

        this.playBtn.addEventListener('click', () => this.toggle());
        this.audio.addEventListener('loadedmetadata', () => this.onMetadata());
        this.audio.addEventListener('timeupdate', () => this.onTime());
        this.audio.addEventListener('play', () => this.onPlay());
        this.audio.addEventListener('pause', () => { this.setPlaying(false); this.savePosition(true); });
        this.audio.addEventListener('ended', () => this.onEnded());

        this.seekInput.addEventListener('input', () => {
          this.isSeeking = true;
          this.paint(this.seekInput);
          this.currentEl.textContent = this.format((this.seekInput.value / 100) * this.audio.duration);
        });
        this.seekInput.addEventListener('change', () => {
          if (isFinite(this.audio.duration)) this.audio.currentTime = (this.seekInput.value / 100) * this.audio.duration;
          this.isSeeking = false;
        });

        this.volumeInput.addEventListener('input', () => {
          this.audio.volume = Number(this.volumeInput.value);
          this.audio.muted = this.audio.volume === 0;
          this.updateMute();
        });
        this.muteBtn.addEventListener('click', () => {
          this.audio.muted = !this.audio.muted;
          if (!this.audio.muted && this.audio.volume === 0) { this.audio.volume = 0.6; this.volumeInput.value = 0.6; }
          this.updateMute();
        });
        this.speedBtn.addEventListener('click', () => {
          this.speedIndex = (this.speedIndex + 1) % this.speeds.length;
          this.audio.playbackRate = this.speeds[this.speedIndex];
          this.speedBtn.textContent = String(this.speeds[this.speedIndex]).replace('.', ',') + '×';
          this.speedBtn.setAttribute('aria-label', 'Velocidade de reprodução: ' + this.speedLabels[this.speedIndex]);
        });

        this.paint(this.volumeInput);
        if (this.audio.readyState >= 1) this.onMetadata();
      }

      disconnectedCallback() {
        if (this.audio) this.audio.pause();
      }

      toggle() {
        if (this.audio.paused) {
          document.querySelectorAll('ak-audio-player').forEach((p) => { if (p !== this && p.audio) p.audio.pause(); });
          this.audio.play().catch(() => {});
        } else {
          this.audio.pause();
        }
      }

      onMetadata() {
        this.durationEl.textContent = this.format(this.audio.duration);
        try {
          const saved = parseFloat(localStorage.getItem(this.dataset.storageKey));
          if (saved > 5 && saved < this.audio.duration - 10) this.audio.currentTime = saved;
        } catch (e) {}
        this.onTime();
      }

      onTime() {
        if (this.isSeeking || !isFinite(this.audio.duration)) return;
        const pct = (this.audio.currentTime / this.audio.duration) * 100 || 0;
        this.seekInput.value = pct;
        this.paint(this.seekInput);
        this.currentEl.textContent = this.format(this.audio.currentTime);
        this.savePosition(false);
      }

      onPlay() {
        this.setPlaying(true);
        this.setupMediaSession();
        if (!this.started) {
          this.started = true;
          this.track('historia_audio_play');
        }
      }

      onEnded() {
        this.setPlaying(false);
        try { localStorage.removeItem(this.dataset.storageKey); } catch (e) {}
        if (!this.completed) {
          this.completed = true;
          this.track('historia_audio_complete');
        }
      }

      setPlaying(playing) {
        this.classList.toggle('is-playing', playing);
        this.playBtn.setAttribute('aria-label', playing ? 'Pausar a história' : 'Ouvir a história');
        if ('mediaSession' in navigator) navigator.mediaSession.playbackState = playing ? 'playing' : 'paused';
      }

      updateMute() {
        this.classList.toggle('is-muted', this.audio.muted);
        this.muteBtn.setAttribute('aria-label', this.audio.muted ? 'Ativar som' : 'Silenciar');
        this.volumeInput.value = this.audio.muted ? 0 : this.audio.volume;
        this.paint(this.volumeInput);
      }

      savePosition(force) {
        const now = Date.now();
        if (!force && now - this.lastSave < 5000) return;
        this.lastSave = now;
        try { localStorage.setItem(this.dataset.storageKey, String(this.audio.currentTime)); } catch (e) {}
      }

      setupMediaSession() {
        if (!('mediaSession' in navigator) || this.mediaReady) return;
        this.mediaReady = true;
        const artwork = this.dataset.artwork ? [{ src: this.dataset.artwork, sizes: '512x512', type: 'image/jpeg' }] : [];
        navigator.mediaSession.metadata = new MediaMetadata({
          title: this.dataset.title || '',
          artist: this.dataset.artist || '',
          artwork: artwork
        });
        const skip = (s) => { this.audio.currentTime = Math.max(0, Math.min(this.audio.duration, this.audio.currentTime + s)); };
        try {
          navigator.mediaSession.setActionHandler('play', () => this.audio.play());
          navigator.mediaSession.setActionHandler('pause', () => this.audio.pause());
          navigator.mediaSession.setActionHandler('seekbackward', () => skip(-15));
          navigator.mediaSession.setActionHandler('seekforward', () => skip(15));
        } catch (e) {}
      }

      track(name) {
        try {
          if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
            Shopify.analytics.publish(name, { title: this.dataset.title, page: location.pathname });
          }
        } catch (e) {}
      }

      paint(input) {
        const min = Number(input.min), max = Number(input.max);
        input.style.setProperty('--fill', ((Number(input.value) - min) / (max - min)) * 100 + '%');
      }

      format(sec) {
        if (!isFinite(sec)) return '--:--';
        const m = Math.floor(sec / 60);
        const s = Math.floor(sec % 60).toString().padStart(2, '0');
        return m + ':' + s;
      }
    }
    customElements.define('ak-audio-player', AkAudioPlayer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
